import { render, staticRenderFns } from "./AlvaroValidate.vue?vue&type=template&id=b4a8b574"
import script from "./AlvaroValidate.vue?vue&type=script&lang=js"
export * from "./AlvaroValidate.vue?vue&type=script&lang=js"
import style0 from "./AlvaroValidate.vue?vue&type=style&index=0&id=b4a8b574&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports